import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@core/core.module';

import { UploadCsvComponent } from './upload-csv/upload-csv.component';
import { UploadCsvDialogComponent } from './upload-csv/upload-csv-dialog/upload-csv-dialog.component';
import { FirstStepComponent } from './upload-csv/first-step/first-step.component';
import { SecondStepComponent } from './upload-csv/second-step/second-step.component';
import { ThirdStepComponent } from './upload-csv/third-step/third-step.component';

const components = [
	UploadCsvComponent,
	UploadCsvDialogComponent,
	FirstStepComponent,
	SecondStepComponent,
	ThirdStepComponent,
];

@NgModule({
	declarations: [components],
	imports: [CommonModule, CoreModule],
	exports: [...components],
})
export class UploadCsvModule {}
